import React, { useState, useEffect } from 'react'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import Divider from '@material-ui/core/Divider'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { useStyles, MenuProps } from './Form.style'
import { formPlaceHolders } from './From.constants'

import { constants } from 'utils'

const { mapLanguageIdsToEnglishText } = constants
const categoryIdData = [1, 2, 3]

//You can send any of those form Types as a prop to the form componant
//login, insurances, areas, specialities, addArea, cities, chooseCity,chooseCityAndArea

const Form = props => {
  const {
    type,
    dropdownData,
    handleDropdownChange,
    onSubmit,
    disabled,
    formData,
    selectedCountryLangModelArr,
    cityId,
    allRelatedSpecialitiesForMain,
    allRelatedSpecialitiesForSub,
    allMainSpecialtyData,
    handleCityChangeInAreaNeighboursTable,
    handleAreaChangeInAreaNeighboursTable,
    setSelectedAreaObjState,
    selectedAreaObj
  } = props

  const classes = useStyles()

  const [primaryLangDepValue, setPrimaryLangDepValue] = useState('')
  const [secondaryLangDepValue, setSecondaryLangDepValue] = useState('')
  const [tertiaryLangDepValue, setTertiaryLangDepValue] = useState('')
  const [quaternaryLangDepValue, setQuaternaryLangDepValue] = useState('')
  const [quinaryLangDepValue, setQuinaryLangDepValue] = useState('')
  const [primaryValue, setPrimaryValue] = useState('')
  const [secondaryValue, setSecondaryValue] = useState('')
  const [tertiaryValue, setTertiaryValue] = useState('')
  const [primaryDdValue, setPrimaryDdValue] = useState(0)
  const [secondaryDdValue, setSecondaryDdValue] = useState(0)
  const [tertiaryDdValue, setTertiaryDdValue] = useState(0)
  const [primaryChkValue, setPrimaryChkValue] = useState(0)
  const [selectedTab, setSelectedTab] = useState(1)
  const [secondaryExtraDropdownData, setSecondaryExtraDropdownData] = useState(
    []
  )
  const [tertiaryExtraDropdownData, setTertiaryExtraDropdownData] = useState([])

  useEffect(() => {
    CreateCustomEditFormData()
    setExtraDropDowns()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdownData])

  const setExtraDropDowns = () => {
    if (type === 'areas' || type === 'addArea')
      setSecondaryExtraDropdownData(categoryIdData)
    if (type === 'main specialities')
      setSecondaryExtraDropdownData(allRelatedSpecialitiesForMain)
    if (type === 'sub specialities') {
      setSecondaryExtraDropdownData(allRelatedSpecialitiesForSub)
      setTertiaryExtraDropdownData(allMainSpecialtyData)
    }
    if (type === 'chooseCityAndArea') {
      setSecondaryExtraDropdownData(dropdownData && dropdownData.cities)
      setTertiaryExtraDropdownData(dropdownData && dropdownData.areas)
    }
    if (type === 'addAreaNeighbour') {
      setSecondaryExtraDropdownData(dropdownData && dropdownData.cities)
      setTertiaryExtraDropdownData(dropdownData && dropdownData.areas)
    }
  }

  const CreateCustomEditFormData = () => {
    if (!formData || !formData.LanguageItemModels) return
    if (type === 'areas' || type === 'addArea') {
      let primaryLangDepValueObj = {}
      selectedCountryLangModelArr.forEach(lang => {
        let currentLangObj =
          formData &&
          formData.LanguageItemModels &&
          formData.LanguageItemModels.find(i => i.LanguageId === lang)
        primaryLangDepValueObj = {
          ...primaryLangDepValueObj,
          [`primaryLangDepId_${lang}`]: currentLangObj.Name
        }
      })
      setPrimaryLangDepValue(primaryLangDepValueObj)
      setPrimaryValue(formData.Latitude)
      setSecondaryValue(formData.Longitude)
      setTertiaryValue(
        formData.LanguageItemModels &&
          formData.LanguageItemModels[0] &&
          formData.LanguageItemModels[0].DisplayOrder
      )
      setPrimaryDdValue(formData.CityId)
      setSecondaryDdValue(formData.CategoryId)
    }
    if (type === 'cities') {
      let primaryLangDepValueObj = {}
      selectedCountryLangModelArr.forEach(lang => {
        let currentLangObj =
          formData &&
          formData.LanguageItemModels &&
          formData.LanguageItemModels.find(i => i.LanguageId === lang)
        primaryLangDepValueObj = {
          ...primaryLangDepValueObj,
          [`primaryLangDepId_${lang}`]: currentLangObj.Name
        }
      })
      setPrimaryLangDepValue(primaryLangDepValueObj)
      setPrimaryValue(
        formData.LanguageItemModels &&
          formData.LanguageItemModels[0] &&
          formData.LanguageItemModels[0].DisplayOrder
      )
      setPrimaryChkValue(formData.IsDefault)
    }
    if (type === 'insurances') {
      let primaryLangDepValueObj = {}
      selectedCountryLangModelArr.forEach(lang => {
        let currentLangObj =
          formData &&
          formData.LanguageItemModels &&
          formData.LanguageItemModels.find(i => i.LanguageId === lang)
        primaryLangDepValueObj = {
          ...primaryLangDepValueObj,
          [`primaryLangDepId_${lang}`]: currentLangObj.Name
        }
      })
      setPrimaryLangDepValue(primaryLangDepValueObj)
      setPrimaryValue(
        formData.LanguageItemModels &&
          formData.LanguageItemModels[0] &&
          formData.LanguageItemModels[0].DisplayOrder
      )
    }
    if (type === 'main specialities' || type === 'sub specialities') {
      let primaryLangDepValueObj = {}
      let secondaryLangDepValueObj = {}
      let tertiaryLangDepValueObj = {}
      let quaternaryLangDepValueObj = {}
      let quinaryLangDepValueObj = {}
      selectedCountryLangModelArr.forEach(lang => {
        let currentLangObj =
          formData &&
          formData.LanguageItemModels &&
          formData.LanguageItemModels.find(i => i.LanguageId === lang)
        primaryLangDepValueObj = {
          ...primaryLangDepValueObj,
          [`primaryLangDepId_${lang}`]: currentLangObj.Name
        }
        secondaryLangDepValueObj = {
          ...secondaryLangDepValueObj,
          [`secondaryLangDepId_${lang}`]: currentLangObj.FriendlyName
        }
        tertiaryLangDepValueObj = {
          ...tertiaryLangDepValueObj,
          [`tertiaryLangDepId_${lang}`]: currentLangObj.PreferredName
        }
        quaternaryLangDepValueObj = {
          ...quaternaryLangDepValueObj,
          [`quaternaryLangDepId_${lang}`]: currentLangObj.TitleDisplayName
        }
        quinaryLangDepValueObj = {
          ...quinaryLangDepValueObj,
          [`quinaryLangDepId_${lang}`]: currentLangObj.Description
        }
      })
      setPrimaryLangDepValue(primaryLangDepValueObj)
      setSecondaryLangDepValue(secondaryLangDepValueObj)
      setTertiaryLangDepValue(tertiaryLangDepValueObj)
      setQuaternaryLangDepValue(quaternaryLangDepValueObj)
      setQuinaryLangDepValue(quinaryLangDepValueObj)
      setPrimaryValue(
        formData.LanguageItemModels &&
          formData.LanguageItemModels[0] &&
          formData.LanguageItemModels[0].DisplayOrder
      )
    }
  }

  const onChange = event => {
    let name = event.target.name
    let value = event.target.value
    if (name.includes('primaryLangDepId_'))
      setPrimaryLangDepValue({ ...primaryLangDepValue, [name]: value })
    if (name.includes('secondaryLangDepId_'))
      setSecondaryLangDepValue({ ...secondaryLangDepValue, [name]: value })
    if (name.includes('tertiaryLangDepId_'))
      setTertiaryLangDepValue({ ...tertiaryLangDepValue, [name]: value })
    if (name.includes('quaternaryLangDepId_'))
      setQuaternaryLangDepValue({ ...quaternaryLangDepValue, [name]: value })
    if (name.includes('quinaryLangDepId_'))
      setQuinaryLangDepValue({ ...quinaryLangDepValue, [name]: value })

    if (name.includes('secondaryDropDown'))
      setPrimaryLangDepValue({ ...primaryLangDepValue, [name]: value })
    if (name.includes('primaryLangDepId_'))
      setPrimaryLangDepValue({ ...primaryLangDepValue, [name]: value })
    if (name === 'primary') setPrimaryValue(value)
    if (name === 'secondary') setSecondaryValue(value)
    if (name === 'tertiary') setTertiaryValue(value)
    if (name === 'primaryDd') setPrimaryDdValue(value)
    if (name === 'secondaryDd') setSecondaryDdValue(value)
    if (name === 'tertiaryDd') setTertiaryDdValue(value)
    if (name === 'primaryChk') {
      let val = event.target.checked ? 1 : 0
      setPrimaryChkValue(val)
    }
    if (
      (type === 'chooseCityAndArea' || type === 'addAreaNeighbour') &&
      name === 'secondaryDd'
    ) {
      handleCityChangeInAreaNeighboursTable(value)
    }
    if (type === 'chooseCityAndArea' && name === 'tertiaryDd') {
      setSelectedAreaObjState(value)
      handleAreaChangeInAreaNeighboursTable(value.Id)
    }
  }

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue)
  }

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      formSubmit()
    }
  }

  const formSubmit = () => {
    if (!document.getElementById('custom-form').reportValidity()) return
    onSubmit({
      primaryLangDepValue,
      secondaryLangDepValue,
      tertiaryLangDepValue,
      quaternaryLangDepValue,
      quinaryLangDepValue,
      primaryValue,
      secondaryValue,
      tertiaryValue,
      secondaryDdValue,
      tertiaryDdValue,
      primaryChkValue
    })
  }

  const renderTabs = fieldData => (
    <div>
      <Tabs
        className={classes.tabContent}
        value={'value'}
        onChange={handleTabChange}
        variant="fullWidth"
        indicatorColor="primary"
        centered
      >
        {fieldData.multiTapData &&
          selectedCountryLangModelArr.map(tab => (
            <Tab
              style={{ flexGrow: 1 }}
              className={tab === selectedTab ? classes.selectedTab : ''}
              value={tab}
              id={tab}
              label={mapLanguageIdsToEnglishText[tab]}
            />
          ))}
      </Tabs>
    </div>
  )

  const renderTitle = fieldData => (
    <>
      <Typography
        gutterBottom
        align="center"
        p={5}
        color="primary"
        variant="h5"
      >
        {fieldData.title}
      </Typography>
      <Divider />
      <br />
    </>
  )

  const renderDynamicHelperText = helperText => {
    return (
      <>
        <Typography
          gutterBottom
          align="center"
          p={5}
          color="primary"
          variant="h5"
        >
          {`${helperText} ${selectedAreaObj &&
            selectedAreaObj.LanguageItemModels &&
            selectedAreaObj.LanguageItemModels.find(i => i.LanguageId === 1)
              .Name}`}
        </Typography>
        <br />
      </>
    )
  }

  const renderDropdown = fieldData => (
    <>
      <InputLabel id={fieldData.dropDownTitle}>
        {fieldData.dropDownTitle}
      </InputLabel>
      {type === 'country' ? (
        <Select
          fullWidth
          onChange={handleDropdownChange}
          input={<Input />}
          MenuProps={MenuProps}
        >
          {dropdownData &&
            dropdownData.map(country => (
              <MenuItem
                key={
                  country.LanguageItemModels.find(i => i.LanguageId === 1).Name
                }
                value={country}
              >
                {country.LanguageItemModels.find(i => i.LanguageId === 1).Name}
              </MenuItem>
            ))}
        </Select>
      ) : (
        ''
      )}
      {type === 'chooseCity' ? (
        <Select
          fullWidth
          onChange={handleDropdownChange}
          input={<Input />}
          MenuProps={MenuProps}
        >
          {dropdownData &&
            dropdownData.map(city => (
              <MenuItem key={city.Id} value={city.Id}>
                {city.LanguageItemModels.find(i => i.LanguageId === 1).Name}
              </MenuItem>
            ))}
        </Select>
      ) : (
        ''
      )}
      {type === 'addArea' ? (
        <Select
          fullWidth
          value={primaryDdValue || cityId}
          onChange={event => onChange(event)}
          input={<Input />}
          MenuProps={MenuProps}
          name={fieldData.dropDownId}
        >
          {dropdownData &&
            dropdownData.map(city => (
              <MenuItem key={city.Id} value={city.Id}>
                {city.LanguageItemModels.find(i => i.LanguageId === 1).Name}
              </MenuItem>
            ))}
        </Select>
      ) : (
        ''
      )}
    </>
  )

  const renderPrimaryLangDepField = (fieldData, tab) => (
    <TextField
      variant="filled"
      color="primary"
      onChange={event => onChange(event)}
      fullWidth
      required={fieldData.isPrimaryLangDepRequired}
      label={fieldData.primaryLangDepLabel}
      name={`primaryLangDepId_${tab}`}
      autoComplete={fieldData.primaryLangDepAutoCompleteText}
      autoFocus
      value={primaryLangDepValue[`primaryLangDepId_${tab}`]}
      onKeyDown={handleKeyDown}
    />
  )

  const renderSecondaryLangDepField = (fieldData, tab) => (
    <TextField
      variant="filled"
      color="primary"
      onChange={event => onChange(event)}
      fullWidth
      required={fieldData.isSecondaryLangDepRequired}
      label={fieldData.secondaryLangDepLabel}
      name={`secondaryLangDepId_${tab}`}
      autoComplete={fieldData.secondaryLangDepAutoCompleteText}
      value={secondaryLangDepValue[`secondaryLangDepId_${tab}`]}
      onKeyDown={handleKeyDown}
    />
  )

  const renderTertiaryLangDepField = (fieldData, tab) => (
    <TextField
      variant="filled"
      color="tertiary"
      onChange={event => onChange(event)}
      fullWidth
      required={fieldData.isTertiaryLangDepRequired}
      label={fieldData.tertiaryLangDepLabel}
      name={`tertiaryLangDepId_${tab}`}
      autoComplete={fieldData.tertiaryLangDepAutoCompleteText}
      value={tertiaryLangDepValue[`tertiaryLangDepId_${tab}`]}
      onKeyDown={handleKeyDown}
    />
  )

  const renderQuaternaryLangDepField = (fieldData, tab) => (
    <TextField
      variant="filled"
      color="quaternary"
      onChange={event => onChange(event)}
      fullWidth
      required={fieldData.isQuaternaryLangDepRequired}
      label={fieldData.quaternaryLangDepLabel}
      name={`quaternaryLangDepId_${tab}`}
      autoComplete={fieldData.quaternaryLangDepAutoCompleteText}
      value={quaternaryLangDepValue[`quaternaryLangDepId_${tab}`]}
      onKeyDown={handleKeyDown}
    />
  )

  const renderQuinaryLangDepField = (fieldData, tab) => (
    <TextField
      variant="filled"
      color="quinary"
      onChange={event => onChange(event)}
      fullWidth
      required={fieldData.isQuinaryLangDepRequired}
      label={fieldData.quinaryLangDepLabel}
      name={`quinaryLangDepId_${tab}`}
      autoComplete={fieldData.quinaryLangDepAutoCompleteText}
      value={quinaryLangDepValue[`quinaryLangDepId_${tab}`]}
      onKeyDown={handleKeyDown}
    />
  )

  const renderPrimaryField = fieldData => (
    <TextField
      variant="standard"
      onChange={event => onChange(event)}
      fullWidth
      required={fieldData.isPrimaryRequired}
      label={fieldData.primaryLabel}
      name={fieldData.primaryId}
      type={fieldData.primaryType}
      autoComplete={fieldData.primaryAutoCompleteText}
      value={primaryValue}
      onKeyDown={handleKeyDown}
    />
  )

  const renderSecondaryField = fieldData => (
    <TextField
      variant="standard"
      margin="normal"
      onChange={event => onChange(event)}
      fullWidth
      required={fieldData.isSecondaryRequired}
      label={fieldData.secondaryLabel}
      name={fieldData.secondaryId}
      type={fieldData.secondaryType}
      autoComplete={fieldData.secondaryAutoCompleteText}
      value={secondaryValue}
      onKeyDown={handleKeyDown}
    />
  )

  const renderTertiaryField = fieldData => (
    <TextField
      variant="standard"
      margin="normal"
      onChange={event => onChange(event)}
      fullWidth
      required={fieldData.isTertiaryRequired}
      label={fieldData.tertiaryLabel}
      name={fieldData.tertiaryId}
      type={fieldData.tertiaryType}
      autoComplete={fieldData.tertiaryAutoCompleteText}
      value={tertiaryValue}
      onKeyDown={handleKeyDown}
    />
  )

  const renderFormBody = fieldData => {
    let dataArr = fieldData.multiTapData ? selectedCountryLangModelArr : []
    return (
      <>
        {dataArr.map(tab =>
          !fieldData.dropDownOnly ? (
            <div
              className={classes.tabFormContent}
              style={{ display: tab === selectedTab ? 'block' : 'none' }}
            >
              {fieldData.primaryLangDepLabel &&
                renderPrimaryLangDepField(fieldData, tab)}
              {fieldData.secondaryLangDepLabel &&
                renderSecondaryLangDepField(fieldData, tab)}
              {fieldData.tertiaryLangDepLabel &&
                renderTertiaryLangDepField(fieldData, tab)}
              {fieldData.quaternaryLangDepLabel &&
                renderQuaternaryLangDepField(fieldData, tab)}
              {fieldData.quinaryLangDepLabel &&
                renderQuinaryLangDepField(fieldData, tab)}
            </div>
          ) : (
            ''
          )
        )}

        {fieldData.primaryLabel && renderPrimaryField(fieldData)}

        {fieldData.secondaryLabel && renderSecondaryField(fieldData)}

        {fieldData.tertiaryLabel && renderTertiaryField(fieldData)}
      </>
    )
  }

  const renderExtraDropdowns = fieldData => (
    <>
      {type === 'addArea' ? (
        <>
          <br />
          <br />
          <InputLabel id={fieldData.secondaryDropDownTitle}>
            {fieldData.secondaryDropDownTitle}
          </InputLabel>
          <Select
            fullWidth
            value={secondaryDdValue}
            onChange={event => onChange(event)}
            input={<Input />}
            MenuProps={MenuProps}
            name={fieldData.secondaryDropDownId}
          >
            {secondaryExtraDropdownData &&
              secondaryExtraDropdownData.map(categoryId => (
                <MenuItem key={categoryId} value={categoryId}>
                  {categoryId}
                </MenuItem>
              ))}
          </Select>
          <br />
          <br />
        </>
      ) : (
        ''
      )}
      {type === 'main specialities' || type === 'sub specialities' ? (
        <>
          <br />
          <br />
          <InputLabel id={fieldData.secondaryDropDownTitle}>
            {fieldData.secondaryDropDownTitle}
          </InputLabel>
          <Select
            fullWidth
            value={secondaryDdValue}
            onChange={event => onChange(event)}
            input={<Input />}
            MenuProps={MenuProps}
            name={fieldData.secondaryDropDownId}
          >
            {secondaryExtraDropdownData &&
              secondaryExtraDropdownData.map(speciality => (
                <MenuItem
                  key={speciality.SpecialtyKey}
                  value={speciality.SpecialtyKey}
                >
                  {
                    speciality.LanguageItemModels.find(i => i.LanguageId === 1)
                      .Name
                  }
                </MenuItem>
              ))}
          </Select>
          <br />
          <br />
          {type === 'sub specialities' ? (
            <>
              <InputLabel id={fieldData.tertiaryDropDownTitle}>
                {fieldData.tertiaryDropDownTitle}
              </InputLabel>
              <Select
                fullWidth
                value={tertiaryDdValue}
                onChange={event => onChange(event)}
                input={<Input />}
                MenuProps={MenuProps}
                name={fieldData.tertiaryDropDownId}
              >
                {tertiaryExtraDropdownData &&
                  tertiaryExtraDropdownData.map(speciality => (
                    <MenuItem
                      key={speciality.SpecialtyKey}
                      value={speciality.Id}
                    >
                      {
                        speciality.LanguageItemModels.find(
                          i => i.LanguageId === 1
                        ).Name
                      }
                    </MenuItem>
                  ))}
              </Select>
              <br />
              <br />
            </>
          ) : (
            ''
          )}
        </>
      ) : (
        ''
      )}
      {type === 'chooseCityAndArea' ? (
        <>
          <InputLabel id={fieldData.secondaryDropDownTitle}>
            {fieldData.secondaryDropDownTitle}
          </InputLabel>
          <Select
            fullWidth
            value={secondaryDdValue}
            onChange={event => onChange(event)}
            input={<Input />}
            MenuProps={MenuProps}
            name={fieldData.secondaryDropDownId}
          >
            {secondaryExtraDropdownData &&
              secondaryExtraDropdownData.map(city => (
                <MenuItem key={city.Id} value={city.Id}>
                  {city.LanguageItemModels.find(i => i.LanguageId === 1).Name}
                </MenuItem>
              ))}
          </Select>
          <br />
          <br />
          <InputLabel id={fieldData.tertiaryDropDownTitle}>
            {fieldData.tertiaryDropDownTitle}
          </InputLabel>
          <Select
            fullWidth
            value={tertiaryDdValue}
            onChange={event => onChange(event)}
            input={<Input />}
            MenuProps={MenuProps}
            name={fieldData.tertiaryDropDownId}
          >
            {tertiaryExtraDropdownData &&
              tertiaryExtraDropdownData.map(area => (
                <MenuItem key={area.Id} value={area}>
                  {area.LanguageItemModels.find(i => i.LanguageId === 1).Name}
                </MenuItem>
              ))}
          </Select>
        </>
      ) : (
        ''
      )}
      <br />
      <br />
      {type === 'addAreaNeighbour' ? (
        <>
          <InputLabel id={fieldData.secondaryDropDownTitle}>
            {fieldData.secondaryDropDownTitle}
          </InputLabel>
          <Select
            fullWidth
            value={secondaryDdValue}
            onChange={event => onChange(event)}
            input={<Input />}
            MenuProps={MenuProps}
            name={fieldData.secondaryDropDownId}
          >
            {secondaryExtraDropdownData &&
              secondaryExtraDropdownData.map(city => (
                <MenuItem key={city.Id} value={city.Id}>
                  {city.LanguageItemModels.find(i => i.LanguageId === 1).Name}
                </MenuItem>
              ))}
          </Select>
          <br />
          <br />
          <InputLabel id={fieldData.tertiaryDropDownTitle}>
            {fieldData.tertiaryDropDownTitle}
          </InputLabel>
          <Select
            fullWidth
            value={tertiaryDdValue}
            onChange={event => onChange(event)}
            input={<Input />}
            MenuProps={MenuProps}
            name={fieldData.tertiaryDropDownId}
          >
            {tertiaryExtraDropdownData &&
              tertiaryExtraDropdownData.map(area => (
                <MenuItem
                  disabled={area.Id === selectedAreaObj.Id}
                  key={area.Id}
                  value={area.Id}
                >
                  {area.LanguageItemModels.find(i => i.LanguageId === 1).Name}
                </MenuItem>
              ))}
          </Select>
        </>
      ) : (
        ''
      )}
    </>
  )

  const renderCheckbox = fieldData => (
    <>
      {fieldData.checkboxItems &&
        fieldData.checkboxItems.map(checkboxItem => (
          <FormControlLabel
            control={
              <Checkbox
                checked={primaryChkValue === 1}
                inputProps={{ 'aria-label': checkboxItem.label }}
                color="primary"
                name={checkboxItem.id}
                onChange={event => onChange(event)}
              />
            }
            label={checkboxItem.label}
          />
        ))}
    </>
  )

  const renderButton = fieldData => (
    <Button
      form="custom-form"
      disabled={disabled}
      onClick={() => formSubmit()}
      fullWidth
      variant="contained"
      color="primary"
      className={classes.submit}
    >
      {fieldData.submitText}
    </Button>
  )

  return (
    <>
      <CssBaseline />
      <form id="custom-form">
        {formPlaceHolders[type].title && renderTitle(formPlaceHolders[type])}
        {formPlaceHolders[type].helperText &&
          renderDynamicHelperText(formPlaceHolders[type].helperText)}
        {formPlaceHolders[type].hasDropdown &&
          renderDropdown(formPlaceHolders[type])}

        {formPlaceHolders[type].multiTapData &&
          renderTabs(formPlaceHolders[type])}

        {renderFormBody(formPlaceHolders[type])}

        {renderExtraDropdowns(formPlaceHolders[type])}

        {renderCheckbox(formPlaceHolders[type])}
      </form>
      {formPlaceHolders[type].submitText &&
        renderButton(formPlaceHolders[type])}
    </>
  )
}

export default Form
